module.exports = __webpack_public_path__ + "static/media/bagVN.70812e82.png";